// src/components/kempower/QuickLinksCard.jsx
import React from 'react';

export default function QuickLinksCard({ links = [] }) {
  if (!links.length) return null;
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="fw-bold mb-3">Quick Links</h6>
        {links.map((link, i) => (
          <div key={i} className="d-flex justify-content-between align-items-center mb-2 p-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
            <div className="d-flex flex-column">
              <span className="fw-semibold">{link.label}</span>
              {link.subLabel && (
                <small className="text-muted">{link.subLabel}</small>
              )}
            </div>
            <a href={link.url} className="text-decoration-none" target={link.external ? '_blank' : '_self'} rel="noopener noreferrer">
              {link.external ? <i className="bi bi-box-arrow-up-right"></i> : <span> &gt; </span>}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
